import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children, requireAdmin = false, requireSuperAdmin = false, requireMaster = false }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-sm text-[#737A76]" data-testid="auth-loading">Loading…</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  const isMaster = user.role === "master";
  const isSuper = isMaster || ["super_admin", "admin"].includes(user.role);
  const isAdminish = isSuper || user.role === "park_admin";
  if (requireMaster && !isMaster) return <Navigate to="/dashboard" replace />;
  if (requireSuperAdmin && !isSuper) return <Navigate to="/dashboard" replace />;
  if (requireAdmin && !isAdminish) return <Navigate to="/dashboard" replace />;
  return children;
}
